<div class="container-fluid container-xxl gx-lg-10 gx-xxl-0">
    <div class="row align-items-stretch gx-0">
        @for (store of stores; track store) {
            <div class="partner-col col-12 col-md-6 col-xl-4">
                <app-partner-store [store]="store"></app-partner-store>
            </div>
        }
    </div>
</div>
